"use client";

import Autoplay from "embla-carousel-autoplay";
import { useEffect, useMemo } from "react";
import type { CarouselApi } from "../../carousel";

const useAutoplay = (api: CarouselApi, delay: number) => {
  const plugins = useMemo(
    () => [
      Autoplay({
        delay,
        stopOnInteraction: false,
        stopOnMouseEnter: true,
        rootNode: (viewport) => viewport.parentElement,
        breakpoints: {
          "(prefers-reduced-motion: reduce)": { active: false },
        },
      }),
    ],
    [delay],
  );

  useEffect(() => {
    if (!api) {
      return;
    }
    const handleSelect = () => api.plugins().autoplay?.reset();
    api.on("select", handleSelect);
    return () => {
      api.off("select", handleSelect);
    };
  }, [api]);

  return plugins;
};

export default useAutoplay;
